import React from 'react';
import { useTranslation } from 'react-i18next';
import 'swiper/css';
import 'swiper/css/pagination';

import { SVGIconType } from '../../../../constants/svgIcon';
import { AppBar, SvgIcon } from '../../../Molecules';

import { CreateMemoryGameBannerCarousel } from '../../../Molecules/CreateMemoryGameBannerCarousel';

import styles from './CreateMemoryGameSelectTypeTemplate.module.css';

interface CreateMemoryGameSelectTypeTemplateProps {
  onQuickMemoryClick: () => void;
  onSpellingClick: () => void;
}

export const CreateMemoryGameSelectTypeTemplate = (
  props: CreateMemoryGameSelectTypeTemplateProps,
) => {
  const { onQuickMemoryClick, onSpellingClick } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.createMemoryGameSelectTypeTemplate}>
      <AppBar />
      <CreateMemoryGameBannerCarousel />
      <div className={styles.container}>
        <div className={styles.infoSection}>
          <div className={styles.icon}>
            <SvgIcon
              name={SVGIconType.BrainX9}
              width={80}
              height={80}
              stroke={'black'}
              fill={'black'}
            />
          </div>

          <p className={styles.title}>{t('Text to AI Memory Games')}</p>
          <p className={styles.description}>
            {t('Enhance your memory retention by up to 9 times.')}
          </p>

          {/* <div className={styles.helpGuideContainer}>
            <p className={styles.helpGuideMessage}>
              {t(
                'Heed help? View guidelines to learn how to create your own AI Memory Games!',
              )}
            </p>
            <button className={styles.guideButton} onClick={onGuideClick}>
              {t('View Guide')}
            </button>
          </div> */}
        </div>
        <div className={styles.gameOptions}>
          <button
            className={styles.optionButtonSpelling}
            onClick={onSpellingClick}
          >
            <SvgIcon name={SVGIconType.SpellingJoy} width={28} height={28} />
            <span className={styles.typeText}>{t('Spelling JOY')}</span>
            <SvgIcon
              className={styles.rightArrowIcon}
              name={SVGIconType.Arrow}
              height={20}
              width={20}
            />
          </button>
          <button
            className={styles.optionButtonQuickMemory}
            onClick={onQuickMemoryClick}
          >
            <SvgIcon name={SVGIconType.QuickMemoryJoy} width={28} height={28} />
            <span className={styles.typeText}>{t('Quick Memory JOY')}</span>
            <SvgIcon
              className={styles.rightArrowIcon}
              name={SVGIconType.Arrow}
              height={20}
              width={20}
            />
          </button>
        </div>
      </div>
    </div>
  );
};
